import { createAsyncThunk } from '@reduxjs/toolkit';
import { getMicorosoftPodDataByContactId } from 'services/pod';
import { IPodData } from 'services/pod/types';
import { convertSimplifiedToPodData } from 'store/pod/helpers';

interface IProps {
  psaId: number;
  contactId: number;
}

export const ThunkGetMicrosoftPodDataByContactId = createAsyncThunk<IPodData, IProps>(
  'pod/getMicorosoftPodDataByContactId',
  async ({ psaId, contactId }) =>
    getMicorosoftPodDataByContactId(psaId, contactId)
      .then(r => r.data)
      .then(data => convertSimplifiedToPodData(data)),
);
